export enum BURGER_MENU_TYPE {
  HOME = 'Home',
  NAVIGATION = 'Navigation',
  BROWSE_DEPARTMENT = 'BrowseDepartment',
  BROWSE_DEPARTMENT_CATEGORY = 'BrowseDepartmentCategory',
}
